import { motion } from "framer-motion";

export const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
};

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      {...fadeUp}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1], delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function ChapterBadge({ number, label, light = false }) {
  return (
    <Reveal className="flex items-center gap-3">
      <span className={`font-mono text-xs tracking-[0.25em] uppercase ${light ? "text-parchment/60" : "text-charcoal-500"}`}>
        {label}
      </span>
      <span className={`h-px w-16 ${light ? "bg-parchment/25" : "bg-charcoal-900/20"}`} />
    </Reveal>
  );
}
